import getDefaultCoordinateParameters from "./get-default-coordinate-parameters";
import getDefaultTimeoutParameters from "./get-default-timeout-parameters";

/**
 * Default trigger parameters
 * @param {TriggerProps} trigger
 * @param {String} type Parameter type: offset, time,...
 * @param {Boolean} isCoordinateBased
 */
const getDefaultParameters = (trigger, type, isCoordinateBased) => {
  const timeout = trigger.get("timeout");

  const isViewport = type === "viewport";

  const map = new Map([
    [
      "target",
      new Map(
        /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
        ([
          ["is-default", true],
          ["name", "target"],
          [
            "resolutions",
            new Map([
              [
                "current",
                new Map(
                  /** @type {Array<[string, any]>} */ ([
                    ["isNode", true],
                    ["value", null],
                    ["unit", null],
                  ])
                ),
              ],
            ]),
          ],
        ])
      ),
    ],
  ]);

  if (timeout) {
    getDefaultTimeoutParameters(map);
  }

  if (isCoordinateBased || isViewport) {
    getDefaultCoordinateParameters(trigger, map);
  }

  return map;
};

export default getDefaultParameters;
